import Context from './appcontext.js';

function configureContext( data )
{
	let final = Object.assign( {}, Context );

	// Update models
	if ( data.reactContext !== undefined && data.reactContext.models !== undefined )
	{
		final.models.userInfo = data.reactContext.models.cu.data.info;
	}

	// Update settings
	if ( data.errors !== undefined )
	{
		final.settings.errors = data.errors;
	}

	return final;
}

/**
 * Module exports
 * @public
 */
export default configureContext;